/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — Wishlist
   ═══════════════════════════════════════════════════════════════════════════
   Antes deste arquivo o coração era decoração: o clique só alternava uma
   classe de CSS e nada era guardado. Ao recarregar a página, sumia. E o link
   "Favoritos" do cabeçalho apontava para /pages/wishlist, que respondia 404.

   Aqui a lista passa a existir de verdade, guardada no próprio navegador:

     aguas_wishlist  →  ["handle-do-produto", ...]

   Uma chave só para o site inteiro — card da home, card da collection e o
   coração da galeria da PDP leem e escrevem no mesmo lugar.

   LIMITE, dito com todas as letras: isto vive no navegador do cliente. Não
   acompanha quem troca de aparelho nem sobrevive à limpeza de dados, e não
   fica visível no admin. Para isso seria preciso um app de wishlist (é o que
   a CARE usa — o /a/wishlist dela é proxy de app), o que é contratação, não
   código de tema.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.aipWishlist) return;

  var CHAVE = 'aguas_wishlist';

  /* ── Lista por conta ───────────────────────────────────────────────────
     Visitante escreve em aguas_wishlist. Cliente logado escreve em
     aguas_wishlist_c<id>. Assim a lista acompanha a CONTA, e nao o aparelho:
     sair e entrar de novo devolve os mesmos favoritos, e duas pessoas no
     mesmo computador nao misturam listas.

     LIMITE, dito com todas as letras: isto continua sendo localStorage, ou
     seja, o navegador daquele aparelho. A lista NAO atravessa para o celular
     da mesma pessoa. Guardar de verdade na conta exige gravar num metafield
     do cliente, e a vitrine nao tem permissao para escrever isso — so um app
     ou um backend proprio faz. */
  function chave() {
    var id = window.aipClienteId;
    return id ? (CHAVE + '_c' + id) : CHAVE;
  }
  var SELETOR = '[data-aip-wish], .aip-gal-wish, .product-card-2026__wishlist, .aip-pca__wishlist, .aip-col-wishlist';

  function ler() {
    try {
      var l = JSON.parse(localStorage.getItem(chave()) || '[]');
      return Array.isArray(l) ? l.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function gravar(lista) {
    try { localStorage.setItem(chave(), JSON.stringify(lista)); } catch (e) {}
  }

  /* Ao entrar na conta, o que a pessoa favoritou como visitante NAQUELE
     aparelho entra na lista da conta. A lista de visitante nao e apagada: ela
     continua sendo o que aparece se a pessoa sair. */
  function juntarListaDeVisitante() {
    if (!window.aipClienteId) return;
    var deVisitante;
    try { deVisitante = JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch (e) { return; }
    if (!Array.isArray(deVisitante) || !deVisitante.length) return;

    var daConta = ler();
    var mudou = false;
    deVisitante.forEach(function (h) {
      if (typeof h === 'string' && h && daConta.indexOf(h) < 0) { daConta.push(h); mudou = true; }
    });
    if (mudou) gravar(daConta);
  }

  function tem(handle) { return ler().indexOf(handle) >= 0; }

  /* O coração dos cards não carrega o handle no HTML. Em vez de mudar o
     markup de três componentes diferentes, ele é deduzido do link do produto
     que existe dentro do mesmo card — e fica gravado no botão para não
     repetir a busca. */
  function handleDoBotao(btn) {
    var h = btn.getAttribute('data-aip-wish');
    if (h) return h;
    var no = btn;
    for (var i = 0; i < 6 && no; i++, no = no.parentElement) {
      var a = no.querySelector && no.querySelector('a[href*="/products/"]');
      if (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) { btn.setAttribute('data-aip-wish', m[1]); return m[1]; }
      }
    }
    return null;
  }

  function alternar(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i >= 0) lista.splice(i, 1); else lista.push(handle);
    gravar(lista);
    sincronizar();
    document.dispatchEvent(new CustomEvent('aip:wishlist', { detail: { lista: lista, handle: handle } }));
    return lista.indexOf(handle) >= 0;
  }

  function remover(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i < 0) return;
    lista.splice(i, 1);
    gravar(lista);
    sincronizar();
    document.dispatchEvent(new CustomEvent('aip:wishlist', { detail: { lista: lista, handle: handle } }));
  }

  /* Deixa todo coração da página coerente com a lista. As duas classes
     antigas continuam sendo aplicadas para o CSS que já existia seguir
     valendo sem eu ter que reescrever folha de cards. */
  function sincronizar() {
    var lista = ler();
    document.querySelectorAll(SELETOR).forEach(function (btn) {
      var h = handleDoBotao(btn);
      if (!h) return;
      var ativo = lista.indexOf(h) >= 0;
      btn.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      btn.classList.toggle('is-active', ativo);
      btn.classList.toggle('aip-wishlist-active', ativo);
    });
    atualizarContador(lista.length);
  }

  /* Bolinha com o total no ícone do cabeçalho */
  function atualizarContador(total) {
    /* O :not() exclui links que pediram para nao receber a bolinha — o do
       rodape, por exemplo, onde o numero grudaria no texto do link. */
    document.querySelectorAll('a[href*="/pages/wishlist"]:not([data-aip-sem-badge])').forEach(function (link) {
      var badge = link.querySelector('.aip-wish-badge');
      if (!total) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'aip-wish-badge';
        link.appendChild(badge);
      }
      badge.textContent = total > 99 ? '99+' : String(total);
    });
  }

  /* Captura: roda antes do listener do próprio botão, então continua
     funcionando mesmo onde algum componente chama stopPropagation. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest(SELETOR) : null;
    if (!btn) return;
    var h = handleDoBotao(btn);
    if (!h) return;
    ev.preventDefault();
    ev.stopPropagation();
    alternar(h);
  }, true);

  window.aipWishlist = {
    lista: ler,
    tem: tem,
    alternar: alternar,
    remover: remover,
    sincronizar: sincronizar
  };

  juntarListaDeVisitante();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizar);
  } else { sincronizar(); }
  window.addEventListener('load', sincronizar);
  document.addEventListener('shopify:section:load', sincronizar);

  /* cards e gaveta são re-renderizados; o coração precisa reaparecer certo */
  var pendente = null;
  new MutationObserver(function () {
    if (pendente) return;
    pendente = setTimeout(function () { pendente = null; sincronizar(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* outra aba mexeu na lista */
  window.addEventListener('storage', function (e) { if (e.key === chave()) sincronizar(); });
})();
